import { Button, makeStyles, Theme } from "@material-ui/core";
import StvPage from "../../../app/ctx-provider/StvPage";
import useAppCtx from "../../../app/ctx-provider/useAppCtx";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles((theme: Theme) => ({

    root: {
        width: 320,
        height: 54,
        borderRadius: 0,
        color: 'white',
        fontSize: 18,
        //background: 'linear-gradient(225.89deg,#fc5e22 -1.1%,#fc992c 99.53%) no-repeat'
    },

    endIcon: {
        height: 'auto',
        width: 17
    }

}));

const BtnTarifrechner: React.FC = () => {
    const { appCtxBo, setAppCtxBo } = useAppCtx();
    const classes = useStyles();

    const onClick = () => {
        appCtxBo.currentPage = StvPage.WIZARD;
        setAppCtxBo(appCtxBo);
    }
    return (
        <Button className={classes.root}
            variant='contained' color='secondary'
            size='large' onClick={onClick}
            endIcon={<ArrowForwardIosIcon classes={{ root: classes.endIcon }} />}>
            Jetzt online abschließen</Button>
    );
}

export default BtnTarifrechner;